<div class="container-fluid">
    <div class="container-ifraime">
        <div class="card-iframe">
            <iframe src="https://drive.google.com/file/d/1GvKNV7zVJs9m13Vud6jWYU6cmBHtQ-8E/preview" allow="autoplay"
                id="videoIframe">
                <span>Caso o vídeo não carregue clique <a href="https://drive.google.com/file/d/1GvKNV7zVJs9m13Vud6jWYU6cmBHtQ-8E/view?usp=sharing"
                        target="_blank">AQUI</a></span>
            </iframe>
        </div>
        <div class="card-info-adicionar">
            <span><h6>DESCRITIVO DE TEMAS E TEMPO</h6><br>
                Introdução: <strong title="Clique aqui para ir para o minuto 00:00" (click)="goToMinute('0')">00:00</strong> ao <strong
                    title="Clique aqui para ir para o minuto 00:29" (click)="goToMinute('29')">00:29</strong><br>
                Regra de trabalho: <strong title="Clique aqui para ir para o minuto 00:30" (click)="goToMinute('30')">00:30</strong> ao <strong
                    title="Clique aqui para ir para o minuto 02:35" (click)="goToMinute('155')">02:35</strong><br>
                Acesso: <strong title="Clique aqui para ir para o minuto 02:36" (click)="goToMinute('157')">02:36</strong> ao <strong
                    title="Clique aqui para ir para o minuto 03:38" (click)="goToMinute('218')">03:38</strong><br>
                Tela inicial: <strong title="Clique aqui para ir para o minuto 03:37" (click)="goToMinute('217')">03:37</strong> ao <strong
                    title="Clique aqui para ir para o minuto 10:21" (click)="goToMinute('621')">10:21</strong><br>
                Como gerar um orçamento: <strong title="Clique aqui para ir para o minuto 10:22" (click)="goToMinute('622')">10:22</strong> ao <strong
                    title="Clique aqui para ir para o minuto 31:14" (click)="goToMinute('31:14')">31:14</strong><br>
                Relatório: <strong title="Clique aqui para ir para o minuto 31:15" (click)="goToMinute('31:15')">31:15</strong> ao <strong
                    title="Clique aqui para ir para o minuto 34:01" (click)="goToMinute('2041')">34:01</strong>
                <br>
                Atribuição: <strong title="Clique aqui para ir para o minuto 34:02" (click)="goToMinute('2042')">34:02</strong> ao <strong
                    title="Clique aqui para ir para o minuto 35:05" (click)="goToMinute('2105')">35:05</strong>
            </span><br>
            <h5 class="info-e-book">
                Para acessar o E-Book do sistema clique
                <a href="https://drive.google.com/file/d/19xBdFHkA8ysaZWVPstLnfTbVpVpOYSpp/view?usp=sharing" target="_blank">AQUI</a>
            </h5>
        </div>
    </div>
</div>